import cloneDeep from 'lodash/fp/cloneDeep';
import metricsService from '../service/metricsService';
import log from '../service/log';
import i18n from '../i18n';
import variants from '@/utils/enums/alertVariants';

const initialState = {
  analyticsV3: {
    all: null,
    ave: null,
    avr: null,
    ai: null,
  },
};

const getters = {};

const actions = {
  async fetchAnalyticsV3({ commit }, { product, marketplaceBusinessId }) {
    try {
      const integrationSettingsId = marketplaceBusinessId ? `?integrationSettingsIds=${marketplaceBusinessId}` : '';
      const res = await metricsService.fetchAnalyticsV3(product, integrationSettingsId);
      commit('SET_ANALYTICS_STATE', [`${product}`, res.data]);
      //const dummyData = require(`../mock/metricsAnalyticsV3${product}.json`);
      //commit('SET_ANALYTICS_STATE', [`${product}`, dummyData]);
    } catch (e) {
      commit(
        'SET_MESSAGE',
        { variant: variants.DANGER, message: { msg1: i18n.global.t('alerts.analyticsError') } },
        { root: true }
      );
      log(`Error fetching analytics data for product: ${product}`, e);
      throw new Error();
    }
  },
};

const mutations = {
  SET_STATE(state, [key, data]) {
    state[key] = data;
  },
  SET_ANALYTICS_STATE(state, [key, data]) {
    state.analyticsV3[key] = data;
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  getters,
  actions,
  mutations,
};
